import { Col, Row } from "antd";
import styles from "./SingleVideoCall.module.css";
import { BsCameraVideoOffFill, BsFillCameraVideoFill, BsFillMicFill, BsFillMicMuteFill } from "react-icons/bs";
import { MdCallEnd } from "react-icons/md";
import { TextComponent } from "../../../../components";
import { useEffect, useRef, useState } from "react";
import {
  LocalUser,
  RemoteUser,
  useClientEvent,
  useJoin,
  useLocalCameraTrack,
  useLocalMicrophoneTrack,
  usePublish,
  useRTCClient,
  useRemoteAudioTracks,
  useRemoteUsers,
} from "agora-rtc-react";
import { useLocation, useNavigate } from "react-router-dom";
import { VideoCallMiddleware } from "../../../../Store/Middlewares/VideoCallMiddleware";
import { useDispatch, useSelector } from "react-redux";
import { hideRinging } from "../../../../Store/Actions/GeneralActions";
import { TbRefreshDot } from "react-icons/tb";



const SingleVideoCall = () => {
  const dispatch = useDispatch();
  const userData = useSelector(state => state.AuthReducer.user);
  const ringingOptions = useSelector((state) => state.GeneralReducer.ringingOptions);
  const location = useLocation();
  const chatData = location?.state?.data
  const navigate = useNavigate();
  const agoraEngine = useRTCClient();

  const config = {
    appId: '139bdabf155141fb810a1c0de545dd58',
    token: chatData?.token,
    channelName: chatData?.channel_name,
  };

  const [activeConnection, setActiveConnection] = useState(true);

  // track the mic/video state - Turn on Mic and Camera On
  const [micOn, setMic] = useState(true);
  const [cameraOn, setCamera] = useState(true);

  // get local video and mic tracks
  const { localMicrophoneTrack } = useLocalMicrophoneTrack(micOn);
  const { localCameraTrack } = useLocalCameraTrack(cameraOn);

  useJoin(
    {
      appid: config.appId,
      channel: config.channelName,
      token: config.token,
    },
    activeConnection,
  );

  usePublish([localMicrophoneTrack, localCameraTrack]);
 
  useClientEvent(agoraEngine, "user-left", (user) => {
    console.log('user Offline',user)
    leaveChannel()
  });

 

  const remoteUsers = useRemoteUsers();
  const { audioTracks } = useRemoteAudioTracks(remoteUsers);

  audioTracks.forEach((track) => track.play());

  const leaveChannel = async () => {
    setActiveConnection(false)
    dispatch(hideRinging());
    navigate(-1)
  };

  const endCall = async () => {
    dispatch(VideoCallMiddleware.declineCall({ receiver_id: chatData?.receiver_id == userData?.id ? chatData?.caller_id : chatData?.receiver_id, caller_id: userData?.id, channel: config.channelName }))
      .then((data) => {
        leaveChannel()
      })
  };



  return (
    <div className={styles.container}>
      <div className={styles.bgImg}>
        {/* {activeConnection && remoteUsers.length ? (
          <div className={styles.callerDiv}>
            <TextComponent textClass={styles.callerName}>
              {`Please wait for ${chatData?.receiver_id == user?.id ? chatData?.caller_name : chatData?.receiver_name} to join..`}
            </TextComponent>
          </div>
        ) :
          <div className={styles.callerDiv}>
            <TextComponent textClass={styles.callerName}>
              {`${chatData?.receiver_id == user?.id ? chatData?.caller_name : chatData?.receiver_name}`}
            </TextComponent>
          </div>
        } */}

        {remoteUsers.map((user) => (
          <>
            <RemoteUser user={user} />
          </>
        ))}
      </div>
      <div className={styles.pinkBg}></div>

      <Row className={styles.singlePersonRow}>
        <div className={styles.personColGroup}>
          <LocalUser
            audioTrack={localMicrophoneTrack}
            videoTrack={localCameraTrack}
            cameraOn={cameraOn}
            micOn={micOn}
            playAudio={false}
            playVideo={cameraOn}
            className={styles.personImage}
          />
          {/* <TextComponent textClass={styles.personName}>
            {user?.name}
          </TextComponent> */}
        </div>
      </Row>
      <Row className={styles.iconRow}>
        <Col>
          <TbRefreshDot className={styles.icon} onClick={() => setCamera(a => !a)} />
        </Col>
        <Col>
          <div className={styles.redIcon} onClick={endCall}>
            <MdCallEnd className={styles.icon} />
          </div>
        </Col>
        <Col>
          {micOn ? (
            <BsFillMicFill
              className={styles.icon}
              onClick={() => setMic(a => !a)}
            />
          ) : (
            <BsFillMicMuteFill
              className={styles.icon}
              onClick={() => setMic(a => !a)}
            />
          )}
        </Col>
      </Row>
    </div >
  );
};

export default SingleVideoCall;
